import { setElementHtml } from '../../../../helpers/generic-js/dom.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateAccountInfo from './account-info.html'
import { enableListeners } from './listeners.js'

const containerElementId = 'accountDetails'

export function showAccountDetails (params) {
  console.log('showAccountDetails()', params)

  const { browserAppAccount, browserAppUser } = params
  const appAccount = browserAppAccount.data.appAccount

  if (!appAccount) {
    setElementHtml(containerElementId, '')
    return
  }

  let htmlIndex = htmlTemplateAccountInfo

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })

  const accountDetailsElement = setElementHtml(containerElementId, htmlIndex)

  accountDetailsElement.querySelectorAll('[data-slot="accountName"]').forEach(function (oneElement) {
    oneElement.innerHTML = appAccount.name
  })

  enableListeners(accountDetailsElement, browserAppAccount)
}
